import React from 'react'
import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'

type CircularProgressProps = {
  style?: object
}

export default (props: CircularProgressProps) => {
  const { style } = props
  return (
    <Box style={{ height: '100%' }} display="flex" justifyContent="center" alignItems="center">
      <CircularProgress color="inherit" size="2rem" style={style} />
    </Box>
  )
}
